/** Widget types that apply frame/layout styles on their own root element. */
export const SELF_STYLED_WIDGET_TYPES = new Set([
  'text',
  'image',
  'enhanced-text',
  'html',
  'button',
  'video',
  'divider',
  'spacer',
  'two-columns',
  'three-columns',
  'four-columns',
  'accordion',
  'tabs',
  'contact-form',
  'counter',
  'progress-bar',
  'social-media',
  'gallery',
  'post-cards',
  'product-cards',
  'tour-cards',
])

export function widgetHandlesOwnFrame(type: string): boolean {
  return SELF_STYLED_WIDGET_TYPES.has(type)
}
